import { render } from "./PaginatedTables.vue?vue&type=template&id=3e2c108c"
import script from "./PaginatedTables.vue?vue&type=script&lang=js"
export * from "./PaginatedTables.vue?vue&type=script&lang=js"

import "./PaginatedTables.vue?vue&type=style&index=0&id=3e2c108c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__